import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { BooleanLiteral } from "@babel/types";

interface SavedItemsSliceState {
  savedItemsArray: any;
  getAllItemsIsLoading: boolean;
  getAllItemsCompleted: boolean;
  getAllItemsError: string | undefined;
  getItemByIdRequestSuccess: boolean;
}

const initialState: SavedItemsSliceState = {
  savedItemsArray: [],
  getAllItemsIsLoading: false,
  getAllItemsCompleted: false,
  getAllItemsError: undefined,
  getItemByIdRequestSuccess: false,
};

export const savedItemsSlice = createSlice({
  name: "savedItems",
  initialState,
  reducers: {
    setSavedItems: (state: SavedItemsSliceState, action: PayloadAction<any>) => {
      state.savedItemsArray = action.payload;
    },
    setGetItemByIdRequestState: (state: SavedItemsSliceState, action: PayloadAction<boolean>) => {
      state.getItemByIdRequestSuccess = action.payload;
    },

    setGetAllItemsInProgress: (state: SavedItemsSliceState) => {
      state.getAllItemsIsLoading = true;
      state.getAllItemsCompleted = false;
      state.getAllItemsError = undefined;
    },
    setGetAllItemsCompleted: (state: SavedItemsSliceState, action: PayloadAction<string>) => {
      state.getAllItemsIsLoading = false;
      state.getAllItemsCompleted = true;
      state.getAllItemsError = action.payload;
    },
    setGetAllItemsFailed: (state: SavedItemsSliceState, action: PayloadAction<string>) => {
      state.getAllItemsIsLoading = false;
      state.getAllItemsCompleted = true;
      state.getAllItemsError = action.payload;
    },
  },
});

export const Actions = savedItemsSlice.actions;
export const Reducer = savedItemsSlice.reducer;
